"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCarousel = exports.carouselSchema = void 0;
var yup = require("yup");
var ScheduledItem_1 = require("./ScheduledItem");
exports.carouselSchema = ScheduledItem_1.scheduledItemSchema.shape({
    name: yup
        .object()
        .shape({
        en: yup.string().required(),
        fr: yup.string().optional(),
        nl: yup.string().optional(),
    })
        .required(),
    collectionId: yup.string().required(),
    previewCollectionId: yup.string().required(),
});
function isCarousel(obj) {
    return exports.carouselSchema.isValidSync(obj);
}
exports.isCarousel = isCarousel;
